import React from 'react'
import { useTheme } from '@mui/material'
import { Container, StyledDivider, SubtitleContainer, SubtitleEndText, Text, TextContainer } from './styles'
import type { IconAndTextBlockProps } from './types'

const IconAndTextBlock: React.FC<IconAndTextBlockProps> = ({
  alignIconTop,
  gap,
  icon,
  lineThrough = false,
  overflowSingleLine = false,
  title,
  titleColor,
  variant = 'subtitle1',
  titleTestId,
  subtitle,
  subtitleColor,
  subtitleVariant = 'body2',
  subtitleEndTextVariant = 'caption',
  subtitleTestId,
  titleRef,
  subtitleOverflowSingleLine = false,
  subtitleEndText,
  subtitleEndTextTestId,
}) => {
  const theme = useTheme()
  const showSubtitle: boolean = Boolean(subtitle) || Boolean(subtitleEndText)

  return (
    <Container alignIconTop={alignIconTop} gap={gap}>
      {Boolean(lineThrough) && <StyledDivider color={theme.palette.text.secondary} />}
      {icon}
      <TextContainer>
        <Text
          data-testid={titleTestId}
          overflowSingleLine={overflowSingleLine}
          color={titleColor ?? theme.palette.text.primary}
          variant={variant}
          ref={titleRef}
        >
          {title}
        </Text>
        {showSubtitle && (
          <SubtitleContainer>
            {Boolean(subtitle) && (
              <Text
                data-testid={subtitleTestId}
                overflowSingleLine={overflowSingleLine || subtitleOverflowSingleLine}
                color={subtitleColor ?? theme.palette.text.secondary}
                variant={subtitleVariant}
              >
                {subtitle}
              </Text>
            )}
            {Boolean(subtitleEndText) && (
              <SubtitleEndText
                data-testid={subtitleEndTextTestId}
                color={subtitleColor ?? theme.palette.text.secondary}
                variant={subtitleEndTextVariant}
              >
                {subtitleEndText}
              </SubtitleEndText>
            )}
          </SubtitleContainer>
        )}
      </TextContainer>
    </Container>
  )
}

export default IconAndTextBlock
